import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, withState, withHandlers } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';


import { selectedModule, selectedContent, selectedModuleId, selectedProgramId, getAllSessionsCurrent, getAllSessionsCompleted} from '../redux/selectors';
import { xapiRequest } from '../redux/reducers/xapi';
import { selectUserContent, getUserProgramsFullRequest,selectAssessment, submitMCQ,selectAttempt, toggleAssignmentView, selectUserModule,
  selectUserPrograms, selectUserVersion, resetUserPrograms } from '../redux/reducers/userProgramsFull';
import { toggleThinkToolPopup, toggleUserDashboard, setPopUps } from '../redux/reducers/view';
import {
  saveTimeTaken,
  addComponentStatusRequest,
  saveStatus,
} from '../redux/reducers/addComponentStatus';
import {
  assignmentRequestRequest
} from '../redux/reducers/assignmentRequest';

import ContentCard from './ContentCard';


import { MDBCard, 
  MDBBtn, 
  MDBTabPane, 
  MDBTabContent, 
  MDBNav, 
  MDBNavItem, 
  MDBNavLink, 
  MDBRow,
  MDBIcon} from "mdbreact";

import { STATUSES } from '../constants';
import { commonStyles } from '../styles/styles';
import { convertTime } from '../utils';
import { connectedUsersRequest } from '../redux/reducers/connectedUsers';
import WebinarCard from './Cards/WebinarCard';






const LearnerSessionsList = ({
  selectUserContent,
  selectedContentId,
  handleToggleUserDashboard,
  handleExtensionRequest,
  handleOpen,
  handleSubmit, 
  handleManager,
  handleResubRequest,
  handleThinkToolClick,
  loginReducer,
  handleView,
  handleBack,
  toggleActiveTab,
  completedSessions,
  activeItem,
  currentSessions,
  userProgramsFull,
}) => {
  const renderCurrentSessions = () =>
    (userProgramsFull.programs && currentSessions) &&
    currentSessions.map(item => (
      <div className="col-md-6 col-lg-3" key={item.contentId} style={{width:'100%', paddingLeft:5, paddingRight:5}} >
       {}
       <WebinarCard
contentId={item.contentId}
type={item.type}
name={item.name}
content = {item}
handleView = {handleView}
description={item.description}
start_date={convertTime(item.due_date)}
meetingId = {item.meeting_id}
password = {item.password}
due_date={new Date(item.due_date)}
backgroundImg={item.backgroundImg}
path={item.path}
handleExtensionRequest = {handleExtensionRequest}
handleOpen = {handleOpen}
handleManager = {handleManager}
handleResubRequest = {handleResubRequest}
attempts={item.attempts}
status={item.status}
moduleName = {item.moduleName}
messageCount={item.messageCount}
isSelected={item.contentId === selectedContentId}
openMessages={handleToggleUserDashboard}
selectedContentHandler={selectUserContent}
isTransparent={false}
allowIconClick={
  true
}
/>
      </div>
    ));
    const renderCompletedSessions = () =>
    (userProgramsFull.programs && currentSessions) &&
    completedSessions.map(item => (
      <div className="col-md-6 col-lg-3" key={item.contentId} style={{width:'100%', paddingLeft:5, paddingRight:5}} >
       {}
       <WebinarCard
contentId={item.contentId}
type={item.type}
name={item.name}
content = {item}
handleView = {handleView}
description={item.description}
start_date={convertTime(item.due_date)}
meetingId = {item.meeting_id}
password = {item.password}
due_date={new Date(item.due_date)}
backgroundImg={item.backgroundImg}
path={item.path}
handleExtensionRequest = {handleExtensionRequest}
handleOpen = {handleOpen}
handleManager = {handleManager}
handleResubRequest = {handleResubRequest}
attempts={item.attempts}
status={item.status}
moduleName = {item.moduleName}
messageCount={item.messageCount}
isSelected={item.contentId === selectedContentId}
openMessages={handleToggleUserDashboard}
selectedContentHandler={selectUserContent}
isTransparent={false}
allowIconClick={
  true
}
/>
      </div>
    ));
  return <MDBCard  className="z-depth-2 rounded-0 yellow-card" >
     <MDBBtn
        floating
        left
        tag='a'
        size='sm'
        className='ml-auto ml-4  d-md-none navBack'
        action
        onClick={()=>handleBack()}
      >
      <MDBIcon icon='angle-left' className="secondary-color" size="sm"/>
    </MDBBtn>
      <div className='text-dark gothamBlack text-left pt-3 pl-3 mobile-padding'>
            MY SESSIONS
            </div>
     {/* <MDBBtn
            floating
          
            tag='a'
            className='ml-auto ml-4 '
            action
            style={{position: 'absolute', right: 0}} 
            onClick={()=>toggleAddProgrammePopup(true)}
          >
            <MDBIcon icon='plus' className="success-color" size="md"/>
          </MDBBtn> */}
      <div className="classic-tabs">
        <MDBNav classicTabs className="pt-2 mt-3" style={{backgroundColor:'#EBEBEB'}}  >
          <MDBNavItem>
            
            <MDBNavLink link to="#" active={activeItem==="1"} onClick={() => toggleActiveTab("1")}>
              Current Sessions
            </MDBNavLink>
          </MDBNavItem>
          <MDBNavItem>
            <MDBNavLink link to="#" active={activeItem==='2'} onClick={() => toggleActiveTab("2")}>
             Completed Sessions
            </MDBNavLink>
          </MDBNavItem>
        </MDBNav>
        <MDBTabContent  className="contentScrollProg" activeItem={activeItem}>
          <MDBTabPane tabId="1">
            <MDBRow>{renderCurrentSessions()}</MDBRow>
          </MDBTabPane>
          <MDBTabPane tabId="2">
          <MDBRow>{renderCompletedSessions()}</MDBRow>
          </MDBTabPane>
        </MDBTabContent>
   </div>
    
    
  </MDBCard>
};

const styles = () => ({
  ...commonStyles,
  menuItem: {
    margin: '-8px 0',
  },
});

const mapStateToProps = state => ({
  loginReducer: state.loginReducer,
  selectedProgramId: selectedProgramId(state),
  selectedModuleId:selectedModuleId(state),
  selectedModule: selectedModule(state),
  selectedContent: selectedContent(state),
  currentSessions: getAllSessionsCurrent(state),
  completedSessions: getAllSessionsCompleted(state),
  userProgramsFull: state.userProgramsFullReducer,
  popups: state.viewReducer.popups
});

const mapDispatchToProps = dispatch => ({
  selectUserContent: contentId => dispatch(selectUserContent(contentId)),
  selectUserModule: moduleId => dispatch(selectUserModule(moduleId)),
  selectUserPrograms: moduleId => dispatch(selectUserPrograms(moduleId)),
  selectAssessment: surveyId => dispatch(selectAssessment(surveyId)),
  submitMCQ: value => dispatch(submitMCQ(value)),
  toggleThinkToolPopup: value => dispatch(toggleThinkToolPopup(value)),
  toggleUserDashboard: value => dispatch(toggleUserDashboard(value)),
  xapiRequest: xapiType => dispatch(xapiRequest(xapiType)),
  getUserProgramsFullRequest: () => dispatch(getUserProgramsFullRequest()),
  saveTimeTaken: time => dispatch(saveTimeTaken(time)),
  addComponentStatusRequest: () => dispatch(addComponentStatusRequest()),
  saveStatus: status => dispatch(saveStatus(status)),
  selectAttempt: moduleId => dispatch(selectAttempt(moduleId)),
  toggleAssignmentView: type => dispatch(toggleAssignmentView(type)),
  assignmentRequestRequest: type => dispatch(assignmentRequestRequest(type)),
  selectUserVersion: versionId => dispatch(selectUserVersion(versionId)),
  connectedUserRequest: () => dispatch(connectedUsersRequest()),
  resetUserPrograms: () => dispatch(resetUserPrograms()),
  setPopups: array => dispatch(setPopUps(array))
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('isShowPopup', 'togglePopup', false),
  withState('isShowDocument', 'togglePopupDocument', false),
  withState('notStartedNumber', 'notStartedCounter', 0),
  withState('activeItem','setActiveItem', '1'),
  withHandlers({
    toggleActiveTab: props => (tab) => {
      
      if (props.activeItem !== tab) {
        props.setActiveItem(tab)
      }
    },
    handleBack: props => () => {
     props.resetUserPrograms()
      props.history.push(`/choosesession`);
    },
    handleThinkToolClick: props => item => {
     
      const {
        history,
        selectedProgramId, 
        selectedModuleId,
        selectedModule,
        selectUserContent,
        toggleThinkToolPopup,
        selectUserVersion
      } = props;
      selectUserModule(item.module_id);
      const isPopup = item.savedVersionsPresent;
      
      selectUserContent(item.contentId);
      
      props.xapiRequest({ xapiType: `Opened`});
      if (isPopup && item.type!='Journal') {
        toggleThinkToolPopup(true);
      } else {
        
        if(isPopup){
          selectUserVersion(null)
          history.push(`/tools/${selectedProgramId}/${item.contentId}`);
        }else{
          selectUserVersion(null)
          history.push(`/tools/${selectedProgramId}/${item.contentId}`);
        }
        
      }
    },

    handleManager: props => content => {

      const {
        selectAssessment,
        assignmentRequestRequest,
        handlePopupToggle,
        toggleManagerPopup,
        submitMCQ,
        selectUserPrograms,
        selectUserModule,
        selectUserContent
      } = props;
      
      if(content.program_id){
        // selectUserPrograms(content.program_id);
        // selectUserModule(content.module_id);
      }
        submitMCQ(true);
        selectUserPrograms(content.program_id);
        selectUserModule(content.module_id);
        selectUserContent(content.contentId);
        selectAssessment(content.survey_id);

        toggleManagerPopup(content);
    },
    handlePopupToggle: props => (item, closed, zDepth) => {
      const { isShowPopup, xapiRequest, getUserProgramsFullRequest, selectedContent } = props;
    
      
     
      //xapiRequest({ xapiType: `${xapiType}`});
      if (isShowPopup) {
        getUserProgramsFullRequest();
      }
      if(closed==true){
        var itemToRemove
      
        var tmp = props.popups;
        tmp.splice(props.windowDeleteIndex,1)
        props.setPopups(tmp);
        props.togglePopup(!isShowPopup);
      }else{
        var tmp = props.popups;
        tmp.push(item);
        props.setPopups(tmp);
        props.togglePopup(!isShowPopup);

      }
      
    },
    handlePopupToggleDocument: props => item => {
      const { isShowDocument, xapiRequest, getUserProgramsFullRequest } = props;
      
      if (isShowDocument) {
        getUserProgramsFullRequest();
      }
      props.togglePopupDocument(!isShowDocument);
    },
    handleSaveAnnotations: props => item => {
      
     // props.togglePopup(!isShowPopup);
    },
    handleToggleUserDashboard: props => value => {
      // if (!props.view.isUserDashboardOpened) {
      //   props.toggleUserDashboard(value);
      // }
    },
    
    handlePauseVideo: props => () => {
      const { xapiRequest, selectedContent: item } = props;
      xapiRequest({ xapiType: `Paused${item.type}`, item });
    },
  }),
  withHandlers({
    onModuleClick: props => item => {
      const { handlePopupToggle, handleThinkToolClick, selectUserContent, handlePopupToggleDocument } = props;
      selectUserContent(item.contentId);
      
      if(item.type=='Document'){
        handlePopupToggle(item);
      }else if (item.type !== 'ThinkTool' && item.type !== 'Journal') {
        if(item.type=='Survey' && item.status!='completed'){
          handlePopupToggle(item);
        }else if(item.type!='Survey'){
          handlePopupToggle(item);
        }
       
      } else {
        
        handleThinkToolClick(item);
      }
    },
    handleExtensionRequest: props => item => {
      const {
        selectAssessment,
        assignmentRequestRequest,
        saveStatus,
        addComponentStatusRequest
      } = props;
        
        selectAssessment(item.survey_id);
        // selectUserAssessment(content.survey_id);
        assignmentRequestRequest('extension');
        
        // saveStatus(STATUSES.extension_request.value);
        // addComponentStatusRequest();
     
      
    },
    handleView: props => (content, item) => {
      const {
        
        selectAssessment,
        selectUserPrograms,
        selectUserModule,
        selectUserContent,
        assignmentRequestRequest,
        toggleAssignmentView,
        toggleAssignmentSubmit,
        submitMCQ,
        selectAttempt,
        handlePopupToggle
      } = props;
     
    
      toggleAssignmentView(true);

      selectAssessment(content.survey_id);
      selectAttempt(item.attempt);

      if(content.program_id){
        
        selectUserPrograms(content.program_id);
        selectUserModule(content.module_id);
      }
        selectUserContent(content.contentId);
        
        
        selectAssessment(content.survey_id);
        submitMCQ(false);
        handlePopupToggle(content);
         
        // selectUserAssessment(content.survey_id);
        // assignmentRequestRequest('retake');
        // saveStatus(STATUSES.resubmission_request.value);
        // addComponentStatusRequest();
      
    },
    handleResubRequest: props => item => {
      const {
        selectAssessment,
        assignmentRequestRequest,
        saveStatus,
        addComponentStatusRequest
      } = props;
        
        selectAssessment(item.survey_id);
        // selectUserAssessment(content.survey_id);
        assignmentRequestRequest('retake');
        
        // saveStatus(STATUSES.extension_request.value);
        // addComponentStatusRequest();
     
      
    },
    handleAssignmentStatus: props => e => {
      const {
        addComponentStatus,
        selectedContent,
        addComponentStatusRequest,
        saveStatus,
      } = props;
      
      if(e=='in progress' && selectedContent.status != 'in progress'){
        
        saveStatus(STATUSES.inProgress.value);
        
        addComponentStatusRequest();
        
      }

      
      if(e==='ready' && selectedContent.status != 'ready'){
        
        saveStatus(STATUSES.ready.value);
        addComponentStatusRequest();
      }

      if(e==='submitted' && selectedContent.status != 'submitted'){
        
        saveStatus(STATUSES.submitted.value);
        addComponentStatusRequest();
      }
      if(e==='completed' && selectedContent.status != 'completed'){
        
        saveStatus(STATUSES.completed.value);
        addComponentStatusRequest();
      }
      if(e==='marking' && selectedContent.status != 'marking'){
        
        saveStatus(STATUSES.marking.value);
        addComponentStatusRequest();
      }

    },
    handleFirstFail: props => e => {
      const {
        selectUserAssessment,
        assignmentRequestRequest,
        addComponentStatusRequest,
        saveStatus,
      } = props;
      
      selectUserAssessment(e.survey_id);
      assignmentRequestRequest('retake');
      // saveStatus(STATUSES.resubmission_request.value);
      // addComponentStatusRequest();

    },
    handleOpen: props => content => {

      const {
        selectAssessment,
        assignmentRequestRequest,
        handlePopupToggle,
        handleAssessmentPopupToggle,
        submitMCQ,
        selectUserPrograms,
        selectUserModule,
        selectUserContent, 
        toggleAssignmentView
      } = props;
      
      if(content.program_id){
        
        // selectUserPrograms(content.program_id);
        // selectUserModule(content.module_id);
      }
        toggleAssignmentView(false);
        selectUserPrograms(content.program_id);
        selectUserModule(content.module_id);
        selectUserContent(content.contentId);
        selectAssessment(content.survey_id);
        submitMCQ(false);
        
        // var tmp = props.popups;
        // tmp.push(content);
        // props.setPopups(tmp);
        handlePopupToggle(content);
    },
    handleSubmit: props => content => {

      const {
        selectAssessment,
        assignmentRequestRequest,
        handlePopupToggle,
        handleAssessmentPopupToggle,
        submitMCQ,
        selectUserPrograms,
        selectUserModule,
        selectUserContent,
      } = props;
      
      if(content.program_id){
        // selectUserPrograms(content.program_id);
        // selectUserModule(content.module_id);
      }
        submitMCQ(true);
        
        selectUserContent(content.contentId);
        selectAssessment(content.survey_id);
        handlePopupToggle(content);
    },
  }),
  withStyles(styles),
)(LearnerSessionsList);

LearnerSessionsList.propTypes = {
  classes: PropTypes.instanceOf(Object),
  selectUserContent: PropTypes.instanceOf(Object),
  selectedModule: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.bool]),
  selectedContentId: PropTypes.number,
  handleToggleUserDashboard: PropTypes.func,
  handlePopupToggle: PropTypes.func,
  isShowPopup: PropTypes.bool,
  selectedContent: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.bool]),
  onModuleClick: PropTypes.func,
  handlePauseVideo: PropTypes.func,
  saveStatus: PropTypes.func,
  addComponentStatusRequest: PropTypes.func,
  saveTimeTaken: PropTypes.func,
  addComponentStatus: PropTypes.instanceOf(Object),
};
